import { FC, RefObject, useState } from 'react';

import { Button, Text, Tooltip, VSpacing } from '@hh.ru/magritte-ui';

import LocalStorageWrapper from 'bloko/common/storage/LocalStorageWrapper';

import useTrls from 'hooks/translation/useTrls';

const LOCAL_STORAGE_SHOW_KEY = 'EXCLUDED_REGIONS_POPUP_SHOWED';

const TrlKeys = {
    body: 'AdCreate.AdForm.AdRegions.ExcludedRegionsInfoTip.body',
    gotIt: 'common.gotIt',
};

export const ExcludedRegionsInfoTip: FC<{ activatorRef: RefObject<HTMLDivElement> }> = ({ activatorRef }) => {
    const trls = useTrls();
    const [show, setShow] = useState(!LocalStorageWrapper.getItem(LOCAL_STORAGE_SHOW_KEY));
    const onClose = () => {
        setShow(false);
        LocalStorageWrapper.setItem(LOCAL_STORAGE_SHOW_KEY, 'true');
    };

    return (
        <Tooltip
            visible={show}
            onClose={onClose}
            closeByClickOutside={false}
            activatorRef={activatorRef}
            placement="right-center"
        >
            <Text>{trls(TrlKeys.body)}</Text>
            <VSpacing default={8} />
            <Button
                mode="primary"
                style="constant"
                size="small"
                onClick={onClose}
                stretched
                data-qa="excluded-regions-info-tip-got-it-button"
            >
                {trls(TrlKeys.gotIt)}
            </Button>
        </Tooltip>
    );
};
